import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";
import {getAppStatus} from "./appAPI"

interface AppState {
underConstruction: boolean
}

const initialState: AppState = {
    underConstruction: false
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(getAppStatus.fulfilled,  (state: AppState, action: PayloadAction<any>) => {
        state.underConstruction = action.payload;
      })
      .addCase(getAppStatus.rejected,  (state: AppState, action: PayloadAction<any>) => {
       
      })
      .addCase(getAppStatus.pending,  (state: AppState, action: PayloadAction<any>) => {
      
      })
  }
});

export const selectUnderConstruction = (state: RootState) =>
  state.app.underConstruction;

export default appSlice.reducer;
